import { render, staticRenderFns } from "./VersionDiagram.vue?vue&type=template&id=5aa17a41"
import script from "./VersionDiagram.vue?vue&type=script&lang=js"
export * from "./VersionDiagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports